import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";

import { getCookieValue } from "../utils/getCookieValue";

export function useTransportProducts({ products = [], onSuccess = () => {}, queryKey = [], ...queryOptions }) {
    const fetchTransportProducts = useCallback(
        (products = []) => {
            return fetch(route("shop.transport"), {
                method: "POST",
                body: JSON.stringify({
                    products,
                }),
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                    "X-Requested-With": "XMLHttpRequest",
                },
            }).then((response) => response.json());
        },
        [products]
    );

    return useQuery({
        ...queryOptions,
        queryKey: [
            "transport",
            products.map((product) => `${product.id}-${product.amount}`),
            ...queryKey,
        ],
        queryFn: async () => {
            const data = await fetchTransportProducts(products);
            onSuccess(data);
            return data;
        },
    });
}
